import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import { Typography, Button, Card } from '@material-ui/core';
import qs from 'qs';
import _ from 'lodash';

import Loader from '../../components/Loader';
import blockProps from '../../utils/blockProps';

class Confirmation extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    isConfirmed: false,
    error: false,
    message: '',
  };

  sendConfirmation = async (value) => {
    this.setState({ loading: true, isConfirmed: false });
    const { candidateID, round } = qs.parse(_.trimStart(this.props.location.search, '?'));
    const confirmationData = {
      candidateID,
      round,
      response: value,
    };

    try {
      await axios.post(
        'https://us-central1-jyp-admin-saas.cloudfunctions.net/confirmation/',
        confirmationData,
      );
      this.setState({
        loading: false,
        isConfirmed: true,
        message: 'Thank you for sending your response',
      });
    } catch (error) {
      this.setState({
        loading: false,
        isConfirmed: true,
        error: true,
        message: 'Unable to submit your response. Please verify your link and try again.',
      });
    }
  };

  render() {
    const { round } = qs.parse(_.trimStart(this.props.location.search, '?'));
    let roundTitle;
    if (round === 'knowledgeTest') {
      roundTitle = 'Selection Process';
    } else if (round === 'selected') {
      roundTitle = 'JYP Session 18-19';
    }

    return (
      <Container>
        <StyledCard>
          {this.state.isConfirmed ? (
            <Message error={this.state.error}>{this.state.message}</Message>
          ) : (
            <div>
              <Typography variant="title" gutterBottom>
                {roundTitle
                  ? `Confirm your availability for the ${roundTitle}`
                  : 'Confirm your availability'}
              </Typography>
              <ActionsContainer>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.sendConfirmation('YES');
                  }}
                >
                  Yes
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.sendConfirmation('MAYBE');
                  }}
                >
                  May Be
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    this.sendConfirmation('NO');
                  }}
                >
                  No
                </Button>
              </ActionsContainer>
            </div>
          )}
        </StyledCard>

        {this.state.loading && <Loader />}
      </Container>
    );
  }
}

export default Confirmation;

const Container = styled.div`
  position: relative;
  widht: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledCard = styled(Card)`
  padding: 16px;
  max-width: 90%;
`;

const ActionsContainer = styled.div`
  margin-top: 24px;

  && {
    display: flex;
    align-items: center;

    & > * + * {
      margin-left: 16px;
    }
  }
`;

const Message = styled(blockProps(Typography, ['error'])).attrs({
  variant: 'body2',
})`
  && {
    color: ${props => (props.error ? 'red' : 'green')};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Confirmation/Confirmation.js